import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-calibration',
  template: `
    <ng-content></ng-content>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  host: {
    '[style.width]': 'mWidth',
    class: 'm-calibration'
  }
})
export class MCalibrationComponent {
  @Input() mWidth = '150px';
}
